// T007 — EUR money helpers. Wire format is "12.34" (two-decimal string).

const EUR_FORMATTER = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatEur = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined || value === "") return EUR_FORMATTER.format(0);
  const numeric = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(numeric)) return EUR_FORMATTER.format(0);
  return EUR_FORMATTER.format(numeric);
};

export const parseEurInput = (value: number | null | undefined): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return "0.00";
  }
  return value.toFixed(2);
};
